module.exports = { "default": require("core-js/library/fn/symbol/has-instance"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol/has-instance.js
// module id = 449
// module chunks = 4 6 7 8 9 10 12 22 23 24 26 27 30 56 57